import * as Yup from 'yup'
// Interfaces For My Report page

export interface MyReportsClass{
    AccountReportCategory:string
    AccountReportId:string
    AccountReportCategoryId:string
    ReportName:string
    ReportDescription:string
    ReportIconPath:string
    AccountId:number
    SystemReportTypeId:string
    SystemReportId:string
    IsConsolidated:boolean
    ReportPageName:string
    ReportOrder:number
    SequenceNo:number
    AccountReportCategorySequence:string
    SystemFeatureCategoryId:string
    SystemFeatureId:string
}
export interface MyReportsStateClass {
    isLoading:boolean
    status: 'idle' | 'loading' | 'failed';
    myReportsList : Array<MyReportsClass> ;
    selectedRecord : Object;
    isReload : boolean;
}

// Interfaces For Report Design page

export interface AccountReportClass{
    AccountReportId: string,
    AccountReportCategoryId: string,
    ReportName: string,
    ReportDescription:string,
    ReportIconPath:string,
    AccountId:number,
    SystemReportTypeId: string,
    SystemReportId:string,
    IsConsolidated:boolean,
    ReportPageName:string,
    ReportOrder:number,
    ShowCompanyLogo:boolean,
    ReportTitle:string,
    ReportHeader:string,
    ReportFooter:string,
    // accountReportColumnList: []
}

  const common = {    
      AccountReportCategoryId: "",
      ReportName:"",
      ReportDescription:"",
      ReportIconPath:"",
      AccountId:0,
      SystemReportTypeId:"",
      SystemReportId:"",
      IsConsolidated:false,
      ReportPageName:"",
      ReportOrder:0,
      ShowCompanyLogo:false,
      ReportTitle:"",
      ReportHeader:"",
      ReportFooter:"",
      accountReportColumnList: []
    };
    
    export const accountReportInitialsForAdd = { ...common };
    
    export const accountReportInitialsForUpdate = {
      ...common,
      AccountReportId: ""
    };

  export interface AccountReportColumnClass{
    SystemReportDataSourceFieldId:string
    SystemReportDataSourceId:string
    SystemReportDataSourceField:string
    SystemReportDataSourceFieldWidth:number
    DefaultAvailable:boolean
    CurrencyField:string
    Formula:string
    SystemReportDataSourceFieldColumnOrder:number
    SystemReportFieldTypeId:string
    SystemReportDataSourceFieldCaption:string
    AccountReportColumnId:string
    Caption:string
    ColumnOrder:number
    SystemReportCalculationTypeId:string
    AccountReportCategoryId:string
    ReportName:string
    ReportDescription:string
    ReportIconPath:string
    AccountId:number
    AccountReportId:string
    SystemReportFieldType:string
    IsAllowSummaryCalculation:boolean
    IsFormulaField:boolean
    ColumnFormula:string
    IsAccountReportGroupExist:boolean
    chkSelect:boolean
}
   export interface CustomReportDesignStateClass {
      isLoading:boolean
      status: 'idle' | 'loading' | 'failed';
      accountReportList : Array<AccountReportClass>;
      accountReportColumnList:Array<AccountReportColumnClass>
      selectedRecord : Object;
      isReload : boolean;
  }

 


// export const createCustomReportDesignInitials = [
//     {
//       AccountReportCategoryId: "",
//       ReportName:"",
//       ReportDescription:"",
//       ReportIconPath:"",
//       AccountId:0,
//       SystemReportTypeId:"",
//       SystemReportId:"",
//       IsConsolidated:false,
//       ReportPageName:"",
//       ReportOrder:0,
//       ShowCompanyLogo:false,
//       ReportTitle:"",
//       ReportHeader:"",
//       ReportFooter:""
//     },
//     {
//       SystemReportDataSourceFieldId:"",
//       SystemReportDataSourceId:"",
//       SystemReportDataSourceField:"",
//       SystemReportDataSourceFieldWidth:0,
//       DefaultAvailable:false,
//       CurrencyField:"",
//       Formula:"",
//       SystemReportDataSourceFieldColumnOrder:0,
//       SystemReportFieldTypeId:"",
//       SystemReportDataSourceFieldCaption:"",
//       AccountReportColumnId:"",
//       Caption:"",
//       ColumnOrder:0,
//       SystemReportCalculationTypeId:"",
//       AccountReportCategoryId:"",
//       ReportName:"",
//       ReportDescription:"",
//       ReportIconPath:"",
//       AccountId:0,
//       AccountReportId:"",
//       SystemReportFieldType:"",
//       IsAllowSummaryCalculation:false,
//       IsFormulaField:false,
//       ColumnFormula:"",
//       IsAccountReportGroupExist:false
//     }
//   ]
  


    // export const createCustomReportDesignSchemas = [
    //   Yup.object({
    //     ReportName: Yup.string().required().label('Report Name'),
    //     ReportDescription: Yup.string().required().label('Report Description'),
    //   }),
    //   Yup.object({
    //     Caption : Yup.string().required().label('Report Caption'),
        
    //   }),
    //   Yup.object({
    //   }),
    //   Yup.object({
    //   }),
    // ]

  